import { Base64 } from "js-base64";

export function postToFlutter(action: string, data: Object) {
    const jsData = JSON.stringify({
        action: action,
        data: data,
    });
    const baseData = Base64.encode(jsData);
    window.parent.postMessage(baseData, "*");
}